<template>
  <el-drawer customClass="el-drawer-right" title="详情" :visible="visible" v-on="$listeners">
    <el-form label-width="130px">
      <template v-if="operateType == 1">
        <el-form-item label="门店名称">
          <span>{{ detail.customerName }}</span>
        </el-form-item>
        <el-form-item label="调账前余额">
          <span>￥{{ detail.adjustBeforeAmount | fen2Yuan }}</span>
        </el-form-item>
        <el-form-item label="调账类型">
          <span>{{ detail.adjustTypeName }}</span>
        </el-form-item>
        <el-form-item label="调整方向">
          <span>{{ detail.adjustAmount > 0 ? '增加' : '减少' }}</span>
        </el-form-item>
        <el-form-item label="调账金额">
          <span>￥{{ Math.abs(detail.adjustAmount) | fen2Yuan }}</span>
        </el-form-item>
        <el-form-item label="凭证">
          <div class="img-list">
            <el-image
              v-for="(url, index) in detail.images"
              :key="index"
              style="width: 60px; height: 60px; margin: 0 4px 4px 0"
              :src="url"
              :preview-src-list="[url]"
            ></el-image>
          </div>
        </el-form-item>
        <el-form-item label="支付流水号">
          <span>{{ detail.flowNo }}</span>
        </el-form-item>
        <!-- <el-form-item label="备注">
          <span>{{ detail.remark }}</span>
        </el-form-item> -->
      </template>
      <template v-if="operateType == 2">
        <el-form-item label="门店名称">
          <span>{{ detail.customerName }}</span>
        </el-form-item>
        <el-form-item label="订单编号">
          <span>{{ detail.orderNo }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>充值</span>
        </el-form-item>
        <el-form-item label="金额">
          <span>￥{{ detail.rechargeAmount | fen2Yuan }}</span>
        </el-form-item>
        <el-form-item label="支付方式">
          <span>{{ paymentChannelMap[detail.paymentChannel] }}</span>
        </el-form-item>
        <el-form-item label="支付时间">
          <span>{{ detail.paymentTime }}</span>
        </el-form-item>
        <el-form-item label="支付流水号">
          <span>{{ detail.paymentFlowNo }}</span>
        </el-form-item>
        <el-form-item label="操作人">
          <span>{{ detail.operatorName }}</span>
        </el-form-item>
      </template>
      <template v-if="operateType == 3">
        <el-form-item label="门店名称">
          <span>{{ detail.customerName }}</span>
        </el-form-item>
        <el-form-item label="订单来源">
          <span>{{ detail.orderSource }}</span>
        </el-form-item>
        <el-form-item label="三方门店ID">
          <span>{{ detail.mtShopId }}</span>
        </el-form-item>
        <el-form-item label="三方订单号">
          <span>{{ detail.mtOrderNo }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>服务费扣减</span>
        </el-form-item>
        <el-form-item label="金额">
          <span>￥{{ detail.serviceAmount | fen2Yuan }}</span>
        </el-form-item>
        <el-form-item label="代运营服务费扣点">
          <span>{{ yuan2Fen(detail.gmvCommission) }}%</span>
        </el-form-item>
        <el-form-item label="订单完成时间">
          <span>{{ detail.orderFinishedTime }}</span>
        </el-form-item>
        <!-- <span class="desc">
          服务费扣减({{ detail.serviceAmount | fen2Yuan }}) = [商品原价总额({{ detail.goodsOriginalAmount | fen2Yuan }})
          + 打包袋({{ detail.packingAmount | fen2Yuan }}) + 配送费({{ detail.deliveryFee | fen2Yuan }}) -
          商家活动支出({{ detail.merchantDiscountAmount | fen2Yuan }})] * TR({{ yuan2Fen(detail.gmvCommission) }}%)
        </span> -->
      </template>
      <template v-if="operateType == 4">
        <el-form-item label="门店名称">
          <span>{{ detail.customerName }}</span>
        </el-form-item>
        <el-form-item label="三方门店ID">
          <span>{{ detail.mtShopId }}</span>
        </el-form-item>
        <el-form-item label="三方订单号">
          <span>{{ detail.mtOrderNo }}</span>
        </el-form-item>
        <el-form-item label="订单来源">
          <span>{{ detail.orderSource }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>服务费返还</span>
        </el-form-item>
        <el-form-item label="金额">
          <span>￥{{ detail.serviceAmount | fen2Yuan }}</span>
        </el-form-item>
        <el-form-item label="代运营服务费扣点">
          <span>{{ yuan2Fen(detail.gmvCommission) }}%</span>
        </el-form-item>
        <el-form-item label="订单退款时间">
          <span>{{ detail.refundTime }}</span>
        </el-form-item>
        <!-- <span class="desc">
          服务费返还({{ detail.serviceAmount | fen2Yuan }}) = [商品退款原价总额({{
            detail.goodsOriginalAmount | fen2Yuan
          }}) + 退款商品打包袋({{ detail.packingAmount | fen2Yuan }}) + 退款商品配送费({{
            detail.deliveryFee | fen2Yuan
          }}) - 退款商品的商家活动支出({{ detail.merchantDiscountAmount | fen2Yuan }})] * TR({{
            yuan2Fen(detail.gmvCommission)
          }}%)
        </span> -->
      </template>
    </el-form>
  </el-drawer>
</template>

<script>
import payDialog from '@/components/global/payDialog';
import ZYPay, { getTradeInfo } from '@zyf2e/checkout-sdk';
import { Loading, Message } from 'element-ui';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    operateType: {
      type: Number,
      default: 0
    },
    flowId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      detail: {},
      paymentChannelMap: {
        wechat_native: '微信支付',
        wechat_app: '微信支付',
        alipay_native: '支付宝支付',
        alipay_app: '支付宝支付'
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getDetail();
      }
    }
  },
  methods: {
    getDetail() {
      let getDetailFn = Fetch.getAccountAdjustFlow;
      if (this.operateType == 2) {
        getDetailFn = Fetch.getAccountRechargeFlow;
      } else if (this.operateType == 3) {
        getDetailFn = Fetch.getAccountServiceFeeFlow;
      } else if (this.operateType == 4) {
        getDetailFn = Fetch.getAccountServiceFeeFlow;
      }
      getDetailFn({ tradeBillId: this.flowId }).then(res => {
        this.detail = res;
      });
    },
    yuan2Fen(val) {
      if (val == null) return '';
      return Math.round(val * 100 * 100) / 100;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer-right {
  width: 620px !important;
  .el-drawer__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 16px 24px;
    margin-bottom: 0;
    span {
      font-size: 16px !important;
      color: #262626;
      font-weight: 500;
    }
  }
  .el-drawer__body {
    padding: 24px 12px 100px;
    overflow-y: auto;

    .el-form-item {
      margin-bottom: 0;
      .img-list {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  .desc {
    display: block;
    padding: 12px;
    background: #eee;
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>
